module.exports = __webpack_public_path__ + "img/right-doc-arrow.5eb5568d.png";